interface currentChild {
  parent: currentChild;
  value: {
    name: String;
  };
}

const BUILD_UP_CHIPS_DATA = (currentChild: currentChild, list: any = []) => {
  const newList = list || [];

  if (currentChild.hasOwnProperty('parent') && currentChild.parent) {
    newList.push({
      name: currentChild.value.name,
      ...currentChild
    });
    return BUILD_UP_CHIPS_DATA(currentChild.parent, newList);
  }

  if (currentChild.hasOwnProperty('name')) {
    newList.push(currentChild);
  }

  return newList.reverse();
};

export default BUILD_UP_CHIPS_DATA;
